import { req } from '../../@api/request';

export default class PaymentService {
  static membershipPlan = async (month: number, type: string) => {
    const result = await req.get(
      `/payment/plan/list?mon=${month}&type=${type}`,
    );
    return result.data;
  };

  static membershipTable = async () => {
    const result = await req.get('/payment/plan');
    return result.data;
  };

  static paymentHistory = async () => {
    const result = await req.get(`/payment/history`);
    return result.data;
  };

  static detailHistory = async (payId: number) => {
    const result = await req.get(`/payment/history/${payId}`);
    return result.data;
  };
}
